import { lazy } from 'react';

import { renderRoutesFromArray } from './renderRoutesFromArray';

const QuizTimeDetails = lazy(() => import('../screens/main/quiztime/quiztime-details'));
const QuizTimeRules = lazy(() => import('../screens/main/quiztime/rules'));
const QuizActivateCode = lazy(() => import('../screens/main/quiztime/quiz-activate-code'));
const QuizTimeList = lazy(() => import('../screens/main/quiztime/quiztime-list'));
const QuizTime = lazy(() => import('../screens/main/quiztime/quiz-single'));
const QuizDuel = lazy(() => import('../screens/main/quiztime/quiz-duel'));
const QuizDuelQuestion = lazy(() => import('../screens/main/quiztime/quiz-duel/question'));
const QuizCreateRound = lazy(() => import('../screens/main/quiztime/quiz-duel/create-round'));
const QuizDuelOverview = lazy(() => import('../screens/main/quiztime/quiz-duel/overview'));
const QuizCompletedDuels = lazy(() => import('../screens/main/quiztime/quiz-completed-duels'));
const QuizSearchMember = lazy(() => import('../screens/main/quiztime/quiz-search-members'));

const routeDefinitions = [
  {
    path: '/quiz-list',
    element: <QuizTimeList />,
  },
  {
    path: '/quiztime-details/:quizSessionId',
    element: <QuizTimeDetails />,
  },
  {
    path: '/quiztime-rules/:quizSessionId',
    element: <QuizTimeRules />,
  },
  {
    path: '/quiztime/:quizSessionId',
    element: <QuizTime />,
  },
  {
    path: '/quiztime/activate-code/:quizSessionId',
    element: <QuizActivateCode />,
  },
  {
    path: '/quiztime/:quizSessionId/completed-duels',
    element: <QuizCompletedDuels />,
  },
  {
    path: '/quiztime/:quizSessionId/search-members',
    element: <QuizSearchMember />,
  },
  {
    path: '/quiz-duel/:duelId/create-round/session/:sessionId',
    element: (
      <QuizDuel>
        <QuizCreateRound />
      </QuizDuel>
    ),
  },
  {
    path: '/quiz-duel/:duelId/round/:roundId/question/:questionId/session/:sessionId',
    element: <QuizDuelQuestion />,
  },
  {
    path: '/quiz-duel/:duelId/overview/session/:sessionId',
    element: (
      <QuizDuel>
        <QuizDuelOverview />
      </QuizDuel>
    ),
  },
];

const quizRoutes = renderRoutesFromArray(routeDefinitions);
export default quizRoutes;
